import { Link } from "react-router-dom";

const pctText = (n) => `${(n ?? 0).toFixed(1)}%`;
const clamp = (n) => Math.max(0, Math.min(100, n ?? 0));

/**
 * Tracks ranked by success rate and volume. Each row drills into the detail
 * page pre-filtered to that track (via buildDetailUrl). Low-n rows are muted.
 */
export default function TrackLeaderboard({ leaderboard, buildDetailUrl }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 mb-6">
      <div className="text-xs font-semibold text-slate-500 uppercase mb-3">
        Track leaderboard{" "}
        <span className="text-slate-300 normal-case">
          — click a track to open the detail page filtered to it
        </span>
      </div>
      <table className="w-full text-sm">
        <thead className="text-[11px] text-slate-400 uppercase border-b border-slate-100">
          <tr>
            <th className="text-left py-2">Track</th>
            <th className="text-right">Races</th>
            <th className="text-right">Legs</th>
            <th className="text-right">Success</th>
            <th className="w-40" />
            <th />
          </tr>
        </thead>
        <tbody>
          {leaderboard.map((t) => {
            const to = buildDetailUrl({ track: t.track });
            return (
              <tr
                key={t.track}
                className={
                  t.lowN
                    ? "border-b border-slate-50 text-slate-400"
                    : "border-b border-slate-50 hover:bg-emerald-50/50"
                }
              >
                <td className="py-2 font-medium">
                  <Link to={to} className="hover:underline">
                    {t.track}
                  </Link>
                  {t.lowN && (
                    <span className="ml-2 text-[10px] bg-slate-100 px-1.5 py-0.5 rounded">
                      low n
                    </span>
                  )}
                </td>
                <td className="text-right">{t.races}</td>
                <td className="text-right">{t.legs}</td>
                <td className="text-right font-semibold">{pctText(t.rate)}</td>
                <td>
                  <div className="h-2 bg-slate-100 rounded">
                    <div
                      className={
                        t.lowN
                          ? "h-2 bg-slate-300 rounded"
                          : "h-2 bg-emerald-500 rounded"
                      }
                      style={{ width: `${clamp(t.rate)}%` }}
                    />
                  </div>
                </td>
                <td className="text-right">
                  <Link
                    to={to}
                    className={
                      t.lowN
                        ? "text-slate-400"
                        : "text-emerald-700 font-semibold"
                    }
                  >
                    detail →
                  </Link>
                </td>
              </tr>
            );
          })}
          {leaderboard.length === 0 && (
            <tr>
              <td colSpan={6} className="py-6 text-center text-slate-400">
                No races in range
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
